import { Component, OnInit, ViewChild, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subject, merge, OperatorFunction } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';
import { DropdownFrameComponent } from '../dropdown-frame/dropdown-frame.component';
import { FlagService, ValidationService, ToastService, DataService } from '@core/services';
import { faInfoCircle, faHouseUser } from '@fortawesome/free-solid-svg-icons';
import { APIClient } from 'src/app/modules/_services/api/@generated';
import { ISO_3166_ALPHA_2_MAPPINGS } from 'iso-3166-ts';
import { FormGroup, FormControl } from '@angular/forms';
import { HIPInsuredPersonDto } from '../../../modules/_services/api/@generated/models';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-contactinfo-juncture',
  templateUrl: './contactinfo-juncture.component.html',
  styleUrls: ['./contactinfo-juncture.component.scss'],
  standalone: false
})
export class ContactinfoJunctureComponent implements OnInit, AfterViewInit {
  faInfoCircle = faInfoCircle;
  faHouseUser = faHouseUser;
  validationStarted = false;
  isoCountries = [];
  settlementLocations = [];
  postalSettlementLocations = [];
  streetLocations = [];
  postalStreetLocations = [];

  public errorMessage = '';
  public errorCity = '';
  public errorPostalCity = '';
  public postalMessage = '';

  //for data reusage in insurantData
  insurantData = this.DropdownFrame.returnInsurantData();

  contactInfoForm = new UntypedFormGroup({
    _stateInput: new UntypedFormControl(''),
    _postCodeInput: new UntypedFormControl(''),
    _settlementInput: new UntypedFormControl(''),
    _streetNameInput: new UntypedFormControl(''),
    _houseNumberInput: new UntypedFormControl(''),
    _postalStateInput: new UntypedFormControl(''),
    _postalPostCodeInput: new UntypedFormControl(''),
    _postalSettlementInput: new UntypedFormControl(''),
    _postalStreetNameInput: new UntypedFormControl(''),
    _postalHouseNumberInput: new UntypedFormControl(''),
    _mobileNumberInput: new UntypedFormControl(''),
    _emailAddressInput: new UntypedFormControl(''),
    _sameAsAddressInput: new UntypedFormControl('')
  });

  @Output() newInsurantDataEvent = new EventEmitter<any>();
  @Output() newInsurantDataLocation = new EventEmitter<string>();

  _isHungarySelected = true;
  _isPostalHungarySelected = true;

//  stateInputChanged = false;
//  postalStateInputChanged = false;

  _postCodeDisabled = false;
  // _settlementDisabled = true;
  // _streetNameDisabled = true;
  // _houseNumberDisabled = true;
  _postalStateDisabled = false;
  _postalPostCodeDisabled = false;
  // _postalSettlementDisabled = true;
  // _postalStreetNameDisabled = true;
  // _postalHouseNumberDisabled = true;

  _postCodeIsValid = false;
  _postalPostCodeIsValid = false;
  _mobileNumberInputIsValid = false;
  _emailAddressInputIsValid = false;

  @ViewChild('state', {static: false}) state: NgbTypeahead;
  @ViewChild('settlement', {static: false}) settlement: NgbTypeahead;
  @ViewChild('street', {static: false}) street: NgbTypeahead;

  focusState$ = new Subject<string>();
  clickState$ = new Subject<string>();
  focusSettlement$ = new Subject<string>();
  clickSettlement$ = new Subject<string>();
  focusStreet$ = new Subject<string>();
  clickStreet$ = new Subject<string>();

  focusPostalState$ = new Subject<string>();
  clickPostalState$ = new Subject<string>();
  focusPostalSettlement$ = new Subject<string>();
  clickPostalSettlement$ = new Subject<string>();
  focusPostalStreet$ = new Subject<string>();
  clickPostalStreet$ = new Subject<string>();

  private hungary = 'Magyarország';
  private countries = { ...ISO_3166_ALPHA_2_MAPPINGS, HU: this.hungary };

//  searchCountry: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) => {
//    const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
//    const clicksWithClosedPopup$ = this.clickState$.pipe(filter(() => !this.state.isPopupOpen()));
//    const inputFocus$ = this.focusState$;
//
//    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
//      map(term => (term === '' ? this.isoCountries : this.isoCountries.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1)).slice(0, 10))
//    );
//  };
//  searchPostalCountry: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) => {
//    const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
//    const clicksWithClosedPopup$ = this.clickPostalState$.pipe(filter(() => !this.state.isPopupOpen()));
//    const inputFocus$ = this.focusPostalState$;
//
//    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
//      map(term => (term === '' ? this.isoCountries : this.isoCountries.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1)).slice(0, 10))
//    );
//  };

  searchSettlement: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
    const clicksWithClosedPopup$ = this.clickSettlement$.pipe(filter(() => !this.settlement.isPopupOpen()));
    const inputFocus$ = this.focusSettlement$;

    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
      map(term => (term === '' ? this.settlementLocations : this.settlementLocations.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1)).slice(0, 10))
    );
  };
  searchPostalSettlement: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
    const clicksWithClosedPopup$ = this.clickPostalSettlement$.pipe(filter(() => !this.settlement.isPopupOpen()));
    const inputFocus$ = this.focusPostalSettlement$;

    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
      map(term => (term === '' ? this.postalSettlementLocations : this.postalSettlementLocations.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1)).slice(0, 10))
    );
  };

  searchStreet: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
    const inputFocus$ = this.focusStreet$;

    return merge(debouncedText$, inputFocus$).pipe(
      map(term => term.length < 1 ? [] : this.streetLocations.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    );
  };
  searchPostalStreet: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
    const inputFocus$ = this.focusPostalStreet$;

    return merge(debouncedText$, inputFocus$).pipe(
      map(term => term.length < 1 ? [] : this.postalStreetLocations.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    );
  };

  constructor(private DropdownFrame: DropdownFrameComponent, public FlagService: FlagService, public ValidationService: ValidationService, public ToastService: ToastService, public DataService: DataService, private api: APIClient) { }

  ngAfterViewInit(): void {
    window.scrollTo(0, this.DataService.fixInfoContainerHeight + 215 + (this.DataService.isPartneri() ? 65 : 0));
  }

  ngOnInit(): void {
    for(let val of Object.values(this.countries)) {
      this.isoCountries.push(val);
    }

    this.contactInfoForm.patchValue({
      _stateInput: this.hungary,
      _postalStateInput: this.hungary
    });

    if(this.insurantData.insuredPerson.email) {
      this.contactInfoForm.patchValue({
        _emailAddressInput: this.insurantData.insuredPerson.email
      });
      this._emailAddressInputIsValid = true;
    }

    const person = sessionStorage.getItem('HIPInsuredPersonFromHIPDto');
    if (person) {
      const personObj = JSON.parse(person);
      if (personObj.insuredPerson && personObj.insuredPerson.addressState) {
        this.loadDataFromSessionStorage(personObj.insuredPerson);
      }
    }

    this.contactInfoForm.get('_settlementInput').disable();
    this.contactInfoForm.get('_streetNameInput').disable();
    this.contactInfoForm.get('_houseNumberInput').disable();
    this.contactInfoForm.get('_postalSettlementInput').disable();
    this.contactInfoForm.get('_postalStreetNameInput').disable();
    this.contactInfoForm.get('_postalHouseNumberInput').disable();
  }

  private loadDataFromSessionStorage(data: HIPInsuredPersonDto): void {
    this.contactInfoForm.patchValue({
      _stateInput: this.countries[data.addressState],
      _postCodeInput: data.addressZip,
      _settlementInput: data.addressCity,
      _streetNameInput: data.addressStreet,
      _houseNumberInput: data.addressHouseNr,
      _postalStateInput: this.countries[data.postalAddressState],
      _postalPostCodeInput: data.postalAddressZip,
      _postalSettlementInput: data.postalAddressCity,
      _postalStreetNameInput: data.postalAddressStreet,
      _postalHouseNumberInput: data.postalAddressHouseNr,
      _mobileNumberInput: data.mobileNumber,
      _emailAddressInput: data.email
    });

    this._postCodeIsValid = true;
    this._postalPostCodeIsValid = true;
    this._mobileNumberInputIsValid = true;
  }

//  stateInputChange() {
//    this.stateInputChanged = true;
//
//    this.contactInfoForm.patchValue({
//      _postCodeInput: '',
//      _settlementInput: '',
//      _streetNameInput: '',
//      _houseNumberInput: ''
//    });
//
//    if(this.contactInfoForm.value['_sameAsAddressInput']) {
//      this.sameAsAddress();
//    }
//
//    if(this.contactInfoForm.value['_stateInput'] === "") {
//      this._isHungarySelected = false;
//      return
//    }
//
//    if(this.contactInfoForm.value['_stateInput'] === "Hungary") {
//      this._isHungarySelected = true;
//      this._postCodeDisabled = false;
//      this._settlementDisabled = true;
//      this._streetNameDisabled = true;
//      this._houseNumberDisabled = true;
//    } else {
//      this._isHungarySelected = false;
//      this._postCodeDisabled = false;
//      this._settlementDisabled = false;
//      this._streetNameDisabled = false;
//      this._houseNumberDisabled = false;
//    }
//  }

//  stateInputFocusOut() {
//    if (this.searchStateCode(this.contactInfoForm.value['_stateInput']) == null) {
//      this.contactInfoForm.get('_stateInput').setValue("");
//    }
//
//  }

//  postalStateInputChange() {
//    this.postalStateInputChanged = true;
//
//    this.contactInfoForm.patchValue({
//      _postalPostCodeInput: '',
//      _postalSettlementInput: '',
//      _postalStreetNameInput: '',
//      _postalHouseNumberInput: ''
//    });
//
//    if(this.contactInfoForm.value['_postalStateInput'] === "") {
//      this._isPostalHungarySelected = false;
//      return
//    }
//    if(this.contactInfoForm.value['_sameAsAddressInput']) {
//      return
//    }
//
//    if(this.contactInfoForm.value['_postalStateInput'] === "Hungary") {
//      this._isPostalHungarySelected = true;
//      this._postalPostCodeDisabled = false;
//      this._postalSettlementDisabled = true;
//      this._postalStreetNameDisabled = true;
//      this._postalHouseNumberDisabled = true;
//    } else {
//      this._isPostalHungarySelected = false;
//      this._postalPostCodeDisabled = false;
//      this._postalSettlementDisabled = false;
//      this._postalStreetNameDisabled = false;
//      this._postalHouseNumberDisabled = false;
//    }
//  }

//  postalStateInputFocusOut() {
//    if (this.searchStateCode(this.contactInfoForm.value['_postalStateInput']) == null) {
//      this.contactInfoForm.get('_postalStateInput').setValue("");
//    }
//  }

  postCodeInputChange() {
    this.contactInfoForm.patchValue({
      _settlementInput: '',
      _streetNameInput: '',
      _houseNumberInput: ''
    });

    const values = this.contactInfoForm.getRawValue();

    if (values._sameAsAddressInput) {
      this.sameAsAddress();
    }

    if (values._postCodeInput === '') {
      // this._settlementDisabled = true;
      this.contactInfoForm.get('_settlementInput').disable();
      // this._streetNameDisabled = true;
      this.contactInfoForm.get('_streetNameInput').disable();
      // this._houseNumberDisabled = true;
      this.contactInfoForm.get('_houseNumberInput').disable();
      return;
//    } else if (!this._isHungarySelected) {
//      // this._settlementDisabled = false;
//      this.contactInfoForm.get('_settlementInput').enable();
//      // this._streetNameDisabled = false;
//      this.contactInfoForm.get('_streetNameInput').enable();
//      // this._houseNumberDisabled = false;
//      this.contactInfoForm.get('_houseNumberInput').enable();
    }

    const zipCode = +values._postCodeInput;

    if (isNaN(zipCode) || values._postCodeInput.length < 4) {
      this._postCodeIsValid = false;
      return;
    } else {
      this._postCodeIsValid = true;
    }

    if (values._postCodeInput.length >= 4 && this._isHungarySelected) {
      this.settlementLocations = [];

      this.errorMessage = '';
      this.api.getAddress({zip: zipCode}).subscribe(response => {
        for (let i in response) {
          this.settlementLocations.push(response[i].city);
        }
        if (response.length === 1) {
          this.contactInfoForm.patchValue({
            _settlementInput: response[0].city
          });
        }
        this._postCodeIsValid = true;
        // this._settlementDisabled = false;
        this.contactInfoForm.get('_settlementInput').enable();
      }, error => {
//        this.ToastService.initializeMessage(error.error.validationErrors[0].errorMessage, 'error');
        this.errorMessage = error.error.validationErrors[0].errorMessage;
      });
    }
  }
  postalPostCodeInputChange() {
    this.contactInfoForm.patchValue({
      _postalSettlementInput: '',
      _postalStreetNameInput: '',
      _postalHouseNumberInput: ''
    });

    const values = this.contactInfoForm.getRawValue();

    if (!values._sameAsAddressInput) {
      if (values._postalPostCodeInput === '') {
        // this._postalSettlementDisabled = true;
        this.contactInfoForm.get('_postalSettlementInput').disable();
        // this._postalStreetNameDisabled = true;
        this.contactInfoForm.get('_postalStreetNameInput').disable();
        // this._postalHouseNumberDisabled = true;
        this.contactInfoForm.get('_postalHouseNumberInput').disable();
        return;
//      } else if (!this._isPostalHungarySelected) {
//        // this._postalSettlementDisabled = false;
//        this.contactInfoForm.get('_postalSettlementInput').enable();
//        // this._postalStreetNameDisabled = false;
//        this.contactInfoForm.get('_postalStreetNameInput').enable();
//        // this._postalHouseNumberDisabled = false;
//        this.contactInfoForm.get('_postalHouseNumberInput').enable();
      }
    }

    const zipCode = +values._postalPostCodeInput;
    if (isNaN(zipCode) || values._postalPostCodeInput.length < 4) {
      this._postalPostCodeIsValid = false;
      return;
    } else {
      this._postalPostCodeIsValid = true;
    }

    if (values._postalPostCodeInput.length >= 4 && this._isPostalHungarySelected && !values._sameAsAddressInput) {
      this.postalSettlementLocations = [];

      this.postalMessage = '';
      this.api.getAddress({zip: zipCode}).subscribe(response => {
        for (let i in response) {
          this.postalSettlementLocations.push(response[i].city);
        }
        if (response.length === 1) {
          this.contactInfoForm.patchValue({
            _postalSettlementInput: response[0].city
          });
        }
        // this._postalSettlementDisabled = false;
        this.contactInfoForm.get('_postalSettlementInput').enable();
      }, error => {
        // this.ToastService.initializeMessage(error.error.validationErrors[0].errorMessage, 'error');
        this.postalMessage = error.error.validationErrors[0].errorMessage;
      });
    }
  }

  settlementInputChange() {
    this.contactInfoForm.patchValue({
      _streetNameInput: '',
      _houseNumberInput: ''
    });

    const values = this.contactInfoForm.getRawValue();

    if (values._sameAsAddressInput) {
      this.sameAsAddress();
    }

    if (values._settlementInput === '') {
      // this._streetNameDisabled = true;
      this.contactInfoForm.get('_streetNameInput').disable();
      // this._houseNumberDisabled = true;
      this.contactInfoForm.get('_houseNumberInput').disable();
      return;
    }

    const zipCode = +values._postCodeInput; // Number(this.contactInfoForm.value['_postCodeInput']);
    const settlement = values._settlementInput; // this.contactInfoForm.value['_settlementInput'];

    if (isNaN(zipCode) || values._postCodeInput.length < 4) {
      this._postCodeIsValid = false;
      return;
    } else {
      this._postCodeIsValid = true;
    }

    if (this._isHungarySelected) {
      this.streetLocations = [];
      this.errorCity = '';

      this.api.getAddress({zip: zipCode, city: settlement}).subscribe(response => {
        for (let i in response) {
          if (!response[i].streetType) {
            this.streetLocations.push(response[i].streetName);
          } else {
            this.streetLocations.push(response[i].streetName + ' ' + response[i].streetType);
          }
        }
        // this._streetNameDisabled = false;
        this.contactInfoForm.get('_streetNameInput').enable();
        // this._houseNumberDisabled = false;
        this.contactInfoForm.get('_houseNumberInput').enable();
      }, error => {
        this.errorCity = error.error.validationErrors[0].errorMessage;
//        this.ToastService.initializeMessage(error.error.validationErrors[0].errorMessage, 'error');
      });
    }
  }
  postalSettlementInputChange() {
    this.contactInfoForm.patchValue({
      _postalStreetNameInput: '',
      _postalHouseNumberInput: ''
    });

    const values = this.contactInfoForm.getRawValue();

    if (values._postalSettlementInput === '' && !values._sameAsAddressInput) {
      // this._postalStreetNameDisabled = true;
      this.contactInfoForm.get('_postalStreetNameInput').disable();
      // this._postalHouseNumberDisabled = true;
      this.contactInfoForm.get('_postalHouseNumberInput').disable();
      return;
    }

    const zipCode = +values._postalPostCodeInput;
    const settlement = values._postalSettlementInput;

    if (isNaN(zipCode) || values._postalPostCodeInput.length < 4) {
      this._postalPostCodeIsValid = false;
      return;
    } else {
      this._postalPostCodeIsValid = true;
    }

    if (this._isPostalHungarySelected && !values._sameAsAddressInput) {
      this.postalStreetLocations = [];
      this.errorPostalCity = '';

      this.api.getAddress({zip: zipCode, city: settlement}).subscribe(response => {
        for (let i in response) {
          if (!response[i].streetType) {
            this.postalStreetLocations.push(response[i].streetName);
          } else {
            this.postalStreetLocations.push(response[i].streetName + ' ' + response[i].streetType);
          }
        }
        // this._postalStreetNameDisabled = false;
        this.contactInfoForm.get('_postalStreetNameInput').enable();
        // this._postalHouseNumberDisabled = false;
        this.contactInfoForm.get('_postalHouseNumberInput').enable();
      }, error => {
        this.errorPostalCity = error.error.validationErrors[0].errorMessage;
//        this.ToastService.initializeMessage(error.error.validationErrors[0].errorMessage, 'error');
      });
    }
  }

  streetInputChange() {
    const values = this.contactInfoForm.getRawValue();

    if (values._sameAsAddressInput) {
      this.sameAsAddress();
    }

//    if(!this._isHungarySelected && this.contactInfoForm.value['_streetNameInput'].length > 0 && !this.contactInfoForm.value['_sameAsAddressInput']) {
//      this._houseNumberDisabled = false;
//      return
//    }
//    if(this.contactInfoForm.value['_streetNameInput'] === '' || (this._isHungarySelected && !(this.streetLocations.includes(this.contactInfoForm.value['_streetNameInput'])))) {
//      this._houseNumberDisabled = true;
//      return
//    }
//    this.contactInfoForm.value['_streetNameInput'].length > 0? this._houseNumberDisabled = false : this._houseNumberDisabled = true;
  }
  postalStreetInputChange() {
//    if(!this._isHungarySelected && this.contactInfoForm.value['_postalStreetNameInput'].length > 0 && !this.contactInfoForm.value['_sameAsAddressInput']) {
//      this._postalHouseNumberDisabled = false;
//      return
//    }
//    if((this.contactInfoForm.value['_postalStreetNameInput'] === '' && !this.contactInfoForm.value['_sameAsAddressInput']) || (this._isPostalHungarySelected && !(this.postalStreetLocations.includes(this.contactInfoForm.value['_postalStreetNameInput'])))) {
//      this._postalHouseNumberDisabled = true;
//      return
//    }
//    this.contactInfoForm.value['_postalStreetNameInput'].length > 0? this._postalHouseNumberDisabled = false : this._postalHouseNumberDisabled = true;
  }

  houseNumberInputChange() {
    const values = this.contactInfoForm.getRawValue();

    if (values._sameAsAddressInput) {
      this.sameAsAddress();
    }
  }

  sameAsAddress() {
    const values = this.contactInfoForm.getRawValue();

    this.contactInfoForm.patchValue({
      sameAsAddressInput: !values._sameAsAddressInput
    });

    if (values._sameAsAddressInput) {
      this.contactInfoForm.patchValue({
        // _postalStateInput: values._stateInput,
        _postalPostCodeInput: values._postCodeInput,
        _postalSettlementInput: values._settlementInput,
        _postalStreetNameInput: values._streetNameInput,
        _postalHouseNumberInput: values._houseNumberInput
      });


      // this._postalStateDisabled = true;
      this._postalPostCodeDisabled = true;
      // this._postalSettlementDisabled = true;
      this.contactInfoForm.get('_postalSettlementInput').disable();
      // this._postalStreetNameDisabled = true;
      this.contactInfoForm.get('_postalStreetNameInput').disable();
      // this._postalHouseNumberDisabled = true;
      this.contactInfoForm.get('_postalHouseNumberInput').disable();

    } else {
      this.contactInfoForm.patchValue({
//        _postalStateInput: '',
        _postalPostCodeInput: '',
        _postalSettlementInput: '',
        _postalStreetNameInput: '',
        _postalHouseNumberInput: ''
      });
      this._postalPostCodeIsValid = false;
      this._postalPostCodeDisabled = false;
    }
  }

  mobileValidation(input: string) {
    if(this.ValidationService.mobileValidator(input)) {
      this._mobileNumberInputIsValid = true;
    } else {
      this._mobileNumberInputIsValid = false;
    }
  }

  emailValidation(input: string) {
    if(this.ValidationService.emailValidator(input)) {
      this._emailAddressInputIsValid = true;
    } else {
      this._emailAddressInputIsValid = false;
    }
  }

  searchStateCode(state: string) {
    for(let i in this.countries) {
      if(this.countries[i] === state) {
        return i;
      }
    }
    return null;
  }

  sendContactInfo() {
    this.validationStarted = true;

    const values = this.contactInfoForm.getRawValue();

    for (let i in values) {
      if (values[i] === '') {
        if (i !== '_sameAsAddressInput') {
          return;
        }
      }
    }

    if (!this._mobileNumberInputIsValid || !this._emailAddressInputIsValid || !this._postCodeIsValid || !this._postalPostCodeIsValid) {
      return;
    }

    let insuredPerson = {
      // data from userdata-juncture
      title: this.insurantData.insuredPerson.title,
      firstName: this.insurantData.insuredPerson.firstName,
      lastName: this.insurantData.insuredPerson.lastName,
      birthName: this.insurantData.insuredPerson.birthName,
      birthDate: this.insurantData.insuredPerson.birthDate,
      birthPlace: this.insurantData.insuredPerson.birthPlace,
      mothersName: this.insurantData.insuredPerson.mothersName,

      addressState: this.searchStateCode(values._stateInput),
      addressZip: values._postCodeInput,
      addressCity: values._settlementInput,
      addressStreet: values._streetNameInput,
      addressHouseNr: values._houseNumberInput,
      postalAddressState: this.searchStateCode(values._postalStateInput),
      postalAddressZip: values._postalPostCodeInput,
      postalAddressCity: values._postalSettlementInput,
      postalAddressStreet: values._postalStreetNameInput,
      postalAddressHouseNr: values._postalHouseNumberInput,
      mobileNumber: values._mobileNumberInput,
      email: values._emailAddressInput,

      // data from socsecurity-juncture
      socialSecurityNumber: this.insurantData.insuredPerson.socialSecurityNumber,
      passport:  this.insurantData.insuredPerson.passport,
      taxNumber:  this.insurantData.insuredPerson.taxNumber
    }

    this.contactinfoJunctureClick();
    this.newInsurantDataLocation.emit('contactInfo');
    this.newInsurantDataEvent.emit(insuredPerson);
  }

  contactinfoJunctureClick() {
    this.DropdownFrame.junctureClick('payfrequencyJunctureFlag', 6);
  }
}
